{
    "filter_button__text": "Filtrer",
    "filter_search__aria_label": "Rechercher dans la liste",
    "filter_modal__title": "Filtres",
    "remove_all": "Tout retirer",
    "quick_filters__customers_my_plus_customers": "🚀 Plus fort potentiel de développement",
    "quick_filters__customers_my_minus_customers": "⚠️ Risque d'attrition le plus élevé",
    "quick_filters__orders_my_open_orders": "Commandes ouvertes",
    "quick_filters__orders_my_billed_orders": "Commandes facturées",
    "quick_filters__quotes_my_open_quotes": "Devis ouverts",
    "date_range_filter__newer_than": "date de moins de",
    "date_range_filter__older_than": "date de plus de",
    "date_range_filter__range_mode": "est dans la période",
    "date_range_filter__please_select": "Veuillez sélectionner",
    "date_range_filter__unit_label": "Unité",
    "date_range_filter__unit_days": "Jours",
    "date_range_filter__unit_weeks": "Semaines",
    "date_range_filter__unit_months": "Mois",
    "price_range_filter__than": "à",
    "price_range_filter__is": "est",
    "price_range_filter__greater": "Supérieur",
    "price_range_filter__smaller": "Inférieur",
    "save_view": "Enregistrer la vue",
    "save_view_dialog__title": "Enregistrer la vue",
    "save_view_dialog__name_placeholder": "Saisir un nom",
    "save_view_dialog__visibility_label": "Qui doit voir cette vue ?",
    "save_view_dialog__visibility_only_me": "Moi uniquement",
    "save_view_dialog__visibility_team": "Toute mon équipe",
    "save_view_dialog__clear_all": "Tout effacer",
    "save_view_dialog__cancel": "Annuler",
    "save_view_dialog__save": "Enregistrer la vue",
    "save_view_dialog__name_required": "Veuillez nommer cette vue",
    "save_view_dialog__name_too_long": "Le nom de la vue ne doit pas dépasser 255 caractères",
    "saved_views__all_views": "Toutes les vues",
    "saved_views__my_views": "Mes vues",
    "saved_views__shared_views": "Vues partagées",
    "saved_views__edit": "Modifier",
    "saved_views__delete": "Supprimer",
    "saved_views__delete_confirmation_title": "Supprimer la vue de filtres",
    "saved_views__delete_confirmation_description": "Voulez-vous vraiment supprimer cette vue de filtres ? Cette action est irréversible.",
    "edit_view_dialog__title": "Modifier la vue",
    "edit_view_dialog__update": "Mettre à jour la vue"
}
